import { StartFootCheck } from "@/features/foot-watch/components/StartFootCheck";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/foot-watch/$diaryId/new/start")({
    component: StartFootCheck,
});
